import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { storage } from '@/utils/storage'

type ThemeMode = 'light' | 'dark'

export const useAppStore = defineStore('app', () => {
  const sidebarCollapsed = ref(false)
  const themeMode = ref<ThemeMode>((storage.get<string>('theme_mode') as ThemeMode) ?? 'light')
  const isMobile = ref(false)
  const drawerVisible = ref(false)
  const reloadKey = ref(0)

  const isDark = computed(() => themeMode.value === 'dark')

  function toggleSidebar() {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  function setThemeMode(mode: ThemeMode) {
    themeMode.value = mode
    storage.set('theme_mode', mode)
    document.documentElement.classList.toggle('dark', mode === 'dark')
  }

  function setMobile(val: boolean) {
    isMobile.value = val
  }

  function setDrawerVisible(val: boolean) {
    drawerVisible.value = val
  }

  function triggerReload() {
    reloadKey.value++
  }

  return {
    sidebarCollapsed,
    themeMode,
    isDark,
    isMobile,
    drawerVisible,
    reloadKey,
    toggleSidebar,
    setThemeMode,
    setMobile,
    setDrawerVisible,
    triggerReload,
  }
})
